export { default } from './truncateText';
